import { SAMPLE_BATTLE_DECKS, sampleBattleDeckForIds } from 'features/battle/sample-decks';
import sampleDeckPowerFile from './sample-deck-power.json';

export type RatedSampleDeckDifficulty = 'easy' | 'hard';

export type SampleDeckPowerRow = {
  easy: number;
  hard: number;
};

export type SampleDeckPowerFile = {
  gamesPerSample: number;
  seed: number;
  stride: number;
  decks: Record<string, SampleDeckPowerRow>;
};

export const SAMPLE_DECK_POWER = sampleDeckPowerFile as SampleDeckPowerFile;

export const sampleDeckPowerParamsMatch = (params: { gamesPerSample: number; seed: number; stride: number }): boolean =>
  SAMPLE_DECK_POWER.gamesPerSample === params.gamesPerSample &&
  SAMPLE_DECK_POWER.seed === params.seed &&
  SAMPLE_DECK_POWER.stride === params.stride;

/** True when every named sample list has Easy and Hard percentages saved under the current rating params. */
export const sampleDeckPowerCoversField = (params: {
  gamesPerSample: number;
  seed: number;
  stride: number;
}): boolean => {
  if (!sampleDeckPowerParamsMatch(params)) return false;
  return SAMPLE_BATTLE_DECKS.every((deck) => {
    const row = SAMPLE_DECK_POWER.decks[deck.id];
    return row != null && Number.isInteger(row.easy) && Number.isInteger(row.hard);
  });
};

/**
 * Saved full-field win rate for a named sample list. `null` when this is not a named sample, the
 * cache is stale, or `SAMPLE_DECKS=1` is regenerating the file.
 */
export const cachedSampleDeckPower = (
  ids: readonly string[],
  opponent: RatedSampleDeckDifficulty,
  params: { gamesPerSample: number; seed: number; stride: number }
): number | null => {
  if (typeof process !== 'undefined' && process.env.SAMPLE_DECKS) return null;
  if (!sampleDeckPowerParamsMatch(params)) return null;
  const sample = sampleBattleDeckForIds(ids);
  const percent = sample ? SAMPLE_DECK_POWER.decks[sample.id]?.[opponent] : undefined;
  return percent == null ? null : percent;
};
